<style rel="stylesheet/scss" scoped lang="scss">
.app-wrapper {
  width: 100%;
  height: 100%;
  position: relative;

  .app-page {
    padding-top: $header_height + 1;
    width: 100%;
    height: 100%;
    box-sizing: border-box;

    .app-page-container {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      position: relative;

      .main-container {
        width: 100%;
        height: 100%;
        padding-left: $side_bar_width;
        box-sizing: border-box;
      }
    }
  }
}
</style>
<template>
  <div class="app-wrapper">
    <app-header></app-header>
    <div class="app-page">
      <div class="app-page-container">
        <app-sidebar></app-sidebar>
        <div class="main-container">
          <app-main></app-main>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import appHeader from './appHeader/appHeader';
import appSidebar from './appSidebar/appSidebar';
import appMain from './appMain/appMain';
export default {
  name: 'Layout',
  components: {
    appHeader,
    appSidebar,
    appMain
  }
};
</script>
